const machine_txt = {
    type: "VA-430D",
    name: "High Speed Computer Knotting Machin",
    description: [
        "APPLICATION",
        "Can be used for men's wear, women's wear, underwear, jeans, knitting and other different applications.",
        "ADVANTAGES",
        "The highest speed in the industry: the maximum speed is 3,200 RPM.",
        "Make high quality sewing completely according to sewing data.",
        "Low noise and vibration.",
        "The rigidity of the higher frame is adopted. Through the latest computer analysis, the various details of the components have been obtained between the good Balance, noise and vibration are minimized. Using the industry's best quality high precision parts, performance more stable.",
        "The sewing area is 40x30mm.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/16/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/16/machine_other/1.png",
        "/assets/machine/16/machine_other/2.png",
    ]
}
export default {machine_txt}